import { render, staticRenderFns } from "./ConvertQuizNoteBox.vue?vue&type=template&id=32eaa704&"
import script from "./ConvertQuizNoteBox.vue?vue&type=script&lang=js&"
export * from "./ConvertQuizNoteBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports